<template>
  <div class="upload-modal__sidebar">
    <v-btn
      height="80"
      variant="text"
      size="x-large"
      :disabled="disabled"
      :color="activeFunc === cropperFuncNames.crop ? 'primary' : null"
      @click="turnFunc(cropperFuncNames.crop)"
    >
      <v-icon>mdi-crop</v-icon>
      <small>Crop</small>
    </v-btn>
    <v-btn
      height="80"
      variant="text"
      size="x-large"
      :disabled="disabled"
      :color="activeFunc === cropperFuncNames.rotate ? 'primary' : null"
      @click="turnFunc(cropperFuncNames.rotate)"
    >
      <v-icon>mdi-rotate-3d-variant</v-icon>
      <small>Rotate</small>
    </v-btn>
    <v-btn
      height="80"
      variant="text"
      size="x-large"
      :disabled="disabled"
      @click="zoomChange(true)"
    >
      <v-icon>mdi-magnify-plus-outline</v-icon>
      <small>Zoom in</small>
    </v-btn>
    <v-btn
      height="80"
      variant="text"
      size="x-large"
      :disabled="disabled"
      @click="zoomChange(false)"
    >
      <v-icon>mdi-magnify-minus-outline</v-icon>
      <small>Zoom out</small>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { CropperFuncNamesEnum } from '@/bundles/Upload/helpers';

export default defineComponent({
  name: 'UploadSidebar',

  props: {
    activeFunc: {
      type: String as PropType<CropperFuncNamesEnum>,
      default: null
    },
    disabled: Boolean,
  },

  emits: ['turnFunc'],

  computed: {
    cropperFuncNames (): typeof CropperFuncNamesEnum {
      return CropperFuncNamesEnum;
    }
  },

  methods: {
    turnFunc (name: CropperFuncNamesEnum) {
      this.$emit('turnFunc', name)
    },
    zoomChange (isZoomIn: boolean) {
      this.$eventBus.$emit('upload:zoom', isZoomIn);
    }
  }
})
</script>

<style lang="scss">
.upload-modal__sidebar {
  display: flex;
  width: 100%;
  max-width: 80px;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));

  .v-btn__content {
    flex-direction: column;
  }
}
</style>
